import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';

import NavbarContent from './NavbarContent';

const useStyles = makeStyles(theme => ({
  appBar: {
    zIndex: 1002,
    boxShadow: 'none',
  },
  toolbar: theme.mixins.toolbar,
}));

const Navbar = props => {
  const classes = useStyles();
  return (
    <AppBar
      position={props.isDemo ? 'fixed' : 'relative'}
      className={classes.appBar}
    >
      <Toolbar className={classes.toolbar}>
        <NavbarContent />
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
